/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { isProductionEnvironment } from '../../../../../utility/environments';
import { coopDevToolsAvailable } from '../../../components/CoopDevTools/coopDevToolsAvailable';

const initialState = {
    mockReclamationUI: false,
    mockReturnUI: false,
    mockUserIsMember: false,
    mockUserIsPunchout: false,
    mockCartIsExpired: false,
    mockCartIsExpiringSoon: false,
    mockEditOrderIsExpiringSoon: false,
    mockEditOrderIsExpired: false,
    a11yDevToolEnabled: coopDevToolsAvailable,
    a11yContextSpecificPageTitleAnnouncementsEnabled: coopDevToolsAvailable,
    a11yFocusOnSoftNavigationEnabled: coopDevToolsAvailable,
    a11yLogsInConsole: false,
    abTestPreviews: {} as Record<string, boolean>,
};

const notInProd = <T>(f: (...params: T[]) => void) => {
    if (isProductionEnvironment) {
        // eslint-disable-next-line no-console
        console.logOnlyInEditMode("This code can't be executed in production environment");
        return () => {};
    }
    return (...params: T[]) => f(...params);
};

type OnlyBoolean<T> = { [K in keyof T]: T[K] extends boolean ? K : never }[keyof T];
type OnlyBooleanFlags = Exclude<OnlyBoolean<typeof initialState>, undefined>;

const slice = createSlice({
    name: 'debug',
    initialState,
    reducers: {
        setBool: (state, action: PayloadAction<{ key: OnlyBooleanFlags; value: boolean }>) => {
            notInProd(() => {
                state[action.payload.key] = action.payload.value;
            })();
        },
        toggleBool: (state, action: PayloadAction<OnlyBooleanFlags>) => {
            notInProd(() => {
                state[action.payload] = !state[action.payload];
            })();
        },
        setAbTestPreview: (
            state,
            action: PayloadAction<{ abTestName: string; value: boolean }>,
        ) => {
            notInProd(() => {
                state.abTestPreviews[action.payload.abTestName] = action.payload.value;
            })();
        },
    },
});

export default slice.reducer;

export const debugActions = slice.actions;
